<template>
    <m-form class="m-form-profile__form" ref="form" :disable-divider="disabled">
        <template #content>
            <v-layout row wrap>
                <v-flex xs12 v-if="$can($actions.read, $abilitySubjects.profile, 'firstName')">
                    <e-input-user-name v-model="form.firstName"
                                       :disabled="disabled"
                                       name="firstName"
                                       ref="firstName"
                                       rules="required"/>
                </v-flex>

                <v-flex xs12 v-if="$can($actions.read, $abilitySubjects.profile, 'lastName')">
                    <e-input-user-surname v-model="form.lastName"
                                          :disabled="disabled"
                                          name="lastName"
                                          ref="lastName"
                                          rules="required"/>
                </v-flex>
                <v-flex xs12>
                    <e-input-user-id
                            v-model="form.username"
                            :tooltip="breakpoints.isLessThanTablet ? null : userIdTooltipText"
                            permanentlyDisabled />
                </v-flex>

                <v-flex xs12 v-if="$can($actions.read, $abilitySubjects.profile, 'position') && !$userRoles.isOwner">
                    <e-input-user-position-function v-model="form.position"
                                                    :disabled="disabled"
                                                    name="position"
                                                    ref="position"/>
                </v-flex>

                <v-flex xs12 v-if="$can($actions.read, $abilitySubjects.profile, 'roles')">
                    <e-input-select-user-role v-model="form.roles"
                                              :default-model="false"
                                              :disabled="!$userRoles.isAdmin"
                                              name="roles" ref="roles"
                                              :innerTooltip="breakpoints.isLessThanTablet"
                    />
                </v-flex>

                <v-flex xs12 v-if="$can($actions.read, $abilitySubjects.profile, 'email')">
                    <e-input-user-email v-model="form.email" rules="required|email" email="true" name="email" ref="email" :disabled="disabled" :tooltip="emailTooltip" />
                </v-flex>

                <v-flex xs12 v-if="$can($actions.read, $abilitySubjects.profile, 'phone')">
                    <e-input-user-phone rules="phone" v-model="form.phone" name="phone" :disabled="disabled" ref="phone"/>
                </v-flex>

                <v-flex xs12 v-if="$can($actions.read, $abilitySubjects.profile, 'mobile')">
                    <e-input-user-mobile-phone rules="mobile" name="mobile" v-model="form.mobile" :disabled="disabled" ref="mobile" :tooltip="mobilePhoneNumberTooltip" />
                </v-flex>
            </v-layout>
        </template>

        <template #buttons v-if="!disabled">
            <m-block-form-buttons
                                  :text="buttonsText"
                                  :isLoading="$wait.waiting(keys.auth.edit_profile)"
                                  @submit="validate"
                                  @cancel="cancel"/>
        </template>
    </m-form>
</template>

<script>
    import pick from 'lodash/pick'
    import MForm from "@modules/forms/m-form";
    import MBlockFormButtons from "@modules/blocks/buttons/concrete/m-block-form-buttons";

    import resources from "@mixins/permissions/_resources";
    import {mapActions} from 'vuex';
    import vuexKeys from '@mixins/includes/_vuexKeys'
    import notifications from "@mixins/includes/_notifications";
    import errorHandler from "@mixins/responses/_errorHandler";

    export default {
        name: "m-form-profile-edit",
        components: {MForm, MBlockFormButtons},
        mixins: [vuexKeys, notifications, resources, errorHandler],
        $_veeValidate: {
            validator: 'new'
        },
        data: () => ({
            form: {
                firstName: null,
                lastName: null,
                userName: null,
                position: null,
                roles: [],
                email: null,
                phone: null,
                mobile: null
            }
        }),
        created() {
            if (this.profile) {
                this.form = Object.assign(
                    {},
                    this.form,
                    pick(this.profile, ['firstName', 'lastName', 'username', 'position', 'roles', 'phone', 'email', 'mobile']));
            }
        },
        computed: {
            buttonsText() {
                return {
                    cancel: this.$t('modules.forms.m-form-profile.buttons.cancel'),
                    submit: this.$t('modules.forms.m-form-profile.buttons.submit')
                }
            },
            profile() {
                return this.$user.attributes;
            },
            disabled() {
                return !this.$can(this.$actions.update, this.$abilitySubjects.profile)
            },
            emailTooltip() {
                if (!this.disabled) return false

                return this.$lodash.isEmpty(this.form.email) ? this.$t('modules.forms.m-form-profile.tooltips.emailEmpty'): this.$t('modules.forms.m-form-profile.tooltips.emailFilled')
            },
            mobilePhoneNumberTooltip() {
                if (!this.disabled) return false

                return this.$lodash.isEmpty(this.form.mobile) ? this.$t('modules.forms.m-form-profile.tooltips.mobilePhoneNumberEmpty') : this.$t('modules.forms.m-form-profile.tooltips.mobilePhoneNumberFilled')
            },
            userIdTooltipText() {
                return this.$t('modules.forms.m-form-company-reg-step4.inputs.user-id.tooltip')
            },
        },
        methods: {
            ...mapActions({
                updateProfile: 'auth/updateProfile',
                requestProfile: 'profile/read',
            }),
            validate() {
                this.$validator.validateAll().then((success) => {
                    if (this.$lodash.isEmpty(this.form.email) && this.$lodash.isEmpty(this.form.mobile)) {
                        this.$validator.errors.add({
                            field: 'email',
                            msg: this.$t('modules.forms.m-form-profile.errors.emailOrMobile')
                        })
                         this.$validator.errors.add({
                            field: 'mobile',
                            msg: this.$t('modules.forms.m-form-profile.errors.emailOrMobile')
                        })
                        return
                    }

                    if (success) {
                        this.submit()
                    } else {
                        const el = document.querySelector(".v-messages__message");
                        el.scrollIntoView({behavior: "smooth" ,block: "center"});
                        this.notify.error(this.$t('notifications.errors.formErrors.invalid'))
                    }
                })
            },
            async submit() {
                try {
                    await this.updateProfile({
                        form: Object.assign({}, this.form, {roles: this.form.roles}),
                        id: this.profile._id
                    });
                    if (this.$user.relationships.profile) {
                        await this.requestProfile({id: this.$user.relationships.profile.data.id});
                    }
                    this.notify.success(this.$t('notifications.profile.editProfile.edited'));
                } catch (e) {
                    this.error.handle(e)
                }
            },
            cancel() {
                this.goBack();
            }
        }
    }
</script>

<style scoped>

</style>
